import React from "react";
import { Label } from "@cars24/turbo-web/lib/label";
import { BodyText } from "@cars24/turbo-web/lib/body-text";
import { NUMBER } from "../../../constants/app-constants";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import PropTypes from "prop-types";
import styles from "./styles.css";

const BenefitCard = ({ benefit, iconUrl }) => {
    const { tokens } = useTokens();
    const { title = "", description = "" } = benefit || {};
    return (
        <div styleName={"styles.benefitCardContainer"}>
            <img src={iconUrl} width={48} height={48} alt="benefit" loading="lazy" />
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px"
                }}
            >
                <Label
                    level={NUMBER.TWO}
                    fontWeight="semibold"
                    color={tokens.text_default_text_primary}
                >
                    {title || ""}
                </Label>
                <BodyText level={NUMBER.TWO} color={tokens.text_default_text_primary}>
                    {description || ""}
                </BodyText>
            </div>
        </div>
    );
};

BenefitCard.propTypes = {
    benefit: PropTypes.object,
    iconUrl: PropTypes.string
};

export default BenefitCard;
